import { Box, Button, Checkbox, Chip, Divider, Grid, IconButton, Link, MenuItem, Paper, Popover, Select, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, } from "@mui/material";
import * as React from "react";
import "../../../scss/main.scss";
import { enqueueSnackbar } from "notistack";
import { useDispatch, useSelector } from "react-redux";
import { closeWeightDisputeRequest } from "@/redux/actions";
import { getCarrierIcon, getNewDateString } from "@/utils/Common";
// import DisputeFilterDrawer from "./DisputeFilterDrawer";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import BackDropComponent from "@/components/BackDrop";
import { BULK_ACTION_OPTIONS_WEIGHT_DISPUTE } from "@/utils/Constants";
import RejectDisputeModal from "./RejectDisputeModal";
import BulkDisputeModal from "./BulkDisputeModal";
const getStatusLabel = (status) => {
    switch (status) {
        case "accepted_by_seller":
            return "Accepted by seller";
        case "auto_accepted_by_seller":
            return "Auto accepted by seller";
        case "accepted_by_carrier":
            return "Accepted by carrier";
        case "rejected_by_carrier":
            return "Rejected by carrier";
        case "auto_rejected_by_carrier":
            return "Auto rejected by carrier";
        case "in_review":
            return "In-review";
        default:
            return "Pending";
    }
};
const getStatusColor = (status) => {
    switch (status) {
        case "accepted_by_seller":
            return "#1976D2";
        case "auto_accepted_by_seller":
            return "#1976D2";
        case "accepted_by_carrier":
            return "#2B873D";
        case "rejected_by_carrier":
            return "#F1583E";
        case "auto_rejected_by_carrier":
            return "#F1583E";
        case "in_review":
            return "#455A64";
        default:
            return "#BB8734";
    }
};
const getBackgroundColor = (status) => {
    switch (status) {
        case "accepted_by_seller":
            return "#E3F2FD";
        case "auto_accepted_by_seller":
            return "#E3F2FD";
        case "accepted_by_carrier":
            return "#EDFBF1";
        case "rejected_by_carrier":
            return "#FBEAE7";
        case "auto_rejected_by_carrier":
            return "#FBEAE7";
        case "in_review":
            return "#ECEFF1";
        default:
            return "#BB8734";
    }
};
const headCells = [
    {
        id: "select",
        disablePadding: true,
        label: "",
    },
    {
        id: "created_at",
        disablePadding: true,
        label: "Created at",
    },
    {
        id: "order_details",
        disablePadding: true,
        label: "Order details",
    },
    {
        id: "product_details",
        disablePadding: true,
        label: "Product details",
    },
    {
        id: "carrier_details",
        disablePadding: true,
        label: "Carrier details",
    },
    {
        id: "manifested_weight",
        disablePadding: true,
        label: "Manifested weight",
    },
    {
        id: "charged_weight",
        disablePadding: true,
        label: "Charged weight",
    },
    {
        id: "excess_weight",
        disablePadding: true,
        label: "Excess weight & Charges",
    },
    {
        id: "status",
        disablePadding: true,
        label: "Status",
    },
    {
        id: "actions",
        disablePadding: true,
        label: "Actions",
    },
];
function EnhancedTableHead(props) {
    const { rowCount, numSelected, onSelectAllClick } = props;
    return (React.createElement(TableHead, { sx: { p: 2 }, style: { background: "#FAFBFC" } },
        React.createElement(TableRow, null, headCells.map((headCell) => (React.createElement(TableCell, { key: headCell.id, align: "left", padding: headCell.id === "select" ? "checkbox" : "normal", className: "orderTable_heading_font" }, headCell.id === "select" ? (React.createElement(Checkbox, { color: "primary", indeterminate: numSelected > 0 && numSelected < rowCount, checked: rowCount > 0 && numSelected === rowCount, onChange: onSelectAllClick, inputProps: { "aria-label": "select all rows" }, sx: {
                transform: "scale(0.8)",
                pt: 0,
            } })) : (headCell.label)))))));
}
const OpenDisputeComponent = ({ selectedCarriersP, setSelectedCarriersP, selectedServicesP, setSelectedServicesP, orderNumbersStrP, setOrderNumbersStrP, AWBstrP, setAWBstrP, handleFilterOpen, handleFilterClose, fetchWeightDiscrepancyData, rowsPerPage, setRowsPerPage, weightDiscrepancy, setWeightDiscrepancy, totalCount, setTotalCount, tabStatus, isFilterApplied, setIsFilterApplied, selectedRow, }) => {
    const [discrepancies, setDiscrepancies] = React.useState([]);
    const [isDetailsSliderOpen, setIsDetailsSliderOpen] = React.useState(false);
    const [rowData, setRowData] = React.useState();
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [selectedRowData, setSelectedRowData] = React.useState();
    const [copyAnchorEl, setCopyAnchorEl] = React.useState(null);
    const [selected, setSelected] = React.useState([]);
    const [bulkAction, setBulkAction] = React.useState("");
    const [orderIds, setOrderIds] = React.useState([]);
    const openCopyPopover = Boolean(copyAnchorEl);
    const copyPopoverId = openCopyPopover ? "simple-popover" : undefined;
    const [isRejectModalOpen, setIsRejectModalOpen] = React.useState(false);
    const [isRejectBulkModalOpen, setIsRejectBulkModalOpen] = React.useState(false);
    const [isFilterDrawerOpen, setIsFilterDrawerOpen] = React.useState(false);
    const [orderId, setOrderId] = React.useState("");
    const formatTimestampToDayMonth = (timestamp) => {
        const date = new Date(timestamp);
        const day = date.getDate().toString().padStart(2, "0");
        const month = date.toLocaleString("default", { month: "short" });
        return `${day}-${month}`;
    };
    const [isBackOpenOpen, setIsBackOpenOpen] = React.useState(false);
    const [page, setPage] = React.useState(0);
    const dispatch = useDispatch();
    const closeWeightDisputeState = useSelector((state) => state.closeWeightDisputeReducer);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [isOrderIdCopied, setIsOrderIdCopied] = React.useState(false);
    const handleClickOrderId = (event, row) => {
        setCopyAnchorEl(event.currentTarget);
        setOrderId(row === null || row === void 0 ? void 0 : row.orderId);
    };
    const handleCopyAWB = (trackingId) => {
        navigator.clipboard.writeText(trackingId);
    };
    const handleCopyClose = () => {
        setCopyAnchorEl(null);
        setIsOrderIdCopied(false);
    };
    const handleCopyOrderId = (orderId) => {
        setIsOrderIdCopied(true);
        navigator.clipboard.writeText(orderId);
    };
    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };
    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };
    const handleDetailsSlider = (row) => {
        setIsDetailsSliderOpen(true);
        setRowData(row);
    };
    React.useEffect(() => {
        if (closeWeightDisputeState && closeWeightDisputeState.data && !closeWeightDisputeState.loading) {
            setIsBackOpenOpen(false);
            enqueueSnackbar(closeWeightDisputeState.data, {
                variant: "success",
            });
        }
        else if (closeWeightDisputeState.error) {
            setIsBackOpenOpen(false);
            if (closeWeightDisputeState.error instanceof Error) {
                enqueueSnackbar(closeWeightDisputeState.error.message, {
                    variant: "error",
                });
            }
        }
    }, [closeWeightDisputeState]);
    React.useEffect(() => {
        if ((AWBstrP || selectedCarriersP || selectedServicesP || orderNumbersStrP) && page === 0) {
            setDiscrepancies([...weightDiscrepancy]);
        }
        else {
            setDiscrepancies((prevShipments) => {
                const combined = [...prevShipments, ...weightDiscrepancy];
                return Array.from(new Set(combined.map((shipment) => shipment.orderId))).map((id) => combined.find((shipment) => shipment.orderId === id));
            });
        }
    }, [weightDiscrepancy]);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        if (discrepancies.length / rowsPerPage <= newPage) {
            fetchWeightDiscrepancyData(rowsPerPage, newPage);
        }
    };
    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setPage(0); // Reset to the first page
        fetchWeightDiscrepancyData(newRowsPerPage, 0);
    };
    const handleRejectDispute = (selectedRowData) => {
        if (selectedRowData) {
            console.log("Selected comming inside", selectedRowData);
            setSelectedRowData(selectedRowData);
            setIsRejectModalOpen(true);
        }
    };
    const handleBulkRejectDispute = (selectedRowData) => {
        console.log("comming inside", selectedRowData);
        if (selectedRowData) {
            setOrderIds(selectedRowData);
            // setSelectedRowData(selectedRowData);
            setIsRejectBulkModalOpen(true);
        }
    };
    const handleAcceptDispute = (selectedRowData) => {
        if (selectedRowData) {
            setIsBackOpenOpen(true);
            dispatch(closeWeightDisputeRequest({
                tenantId: selectedRowData.tenantId,
                batchId: selectedRow === null || selectedRow === void 0 ? void 0 : selectedRow.batchId,
                orderIds: [selectedRowData.orderId],
                weightDisputeStatus: "accepted_by_carrier",
                carrierRejectReason: null,
                carrierRejectFileUrl: null,
            }));
        }
    };
    const handleBulkDisputeDiscrepancy = (selectedRowData) => {
        if (selectedRowData) {
            setIsBackOpenOpen(true);
            dispatch(closeWeightDisputeRequest({
                tenantId: selectedRow === null || selectedRow === void 0 ? void 0 : selectedRow.tenantId,
                batchId: selectedRow === null || selectedRow === void 0 ? void 0 : selectedRow.batchId,
                orderIds: selectedRowData,
                weightDisputeStatus: "accepted_by_carrier",
                carrierRejectReason: null,
                carrierRejectFileUrl: null,
            }));
        }
    };
    const handleDisputeDiscrepancy = (selectedRowData) => {
        if (selectedRowData) {
            setSelectedRowData(selectedRowData);
            setIsDetailsSliderOpen(true);
        }
    };
    const handleClosePopOver = () => {
        setAnchorEl(null);
    };
    const handleClick = (event, row) => {
        setCopyAnchorEl(event.currentTarget);
        setOrderId(row === null || row === void 0 ? void 0 : row.orderId);
    };
    const handleSelectAllClick = (event) => {
        const isChecked = event.target.checked;
        if (isChecked) {
            const newSelected = visibleRows.filter((row) => row.processingStatus === "in_review").map((row) => row.orderId);
            const totalSelected = [...selected, ...newSelected];
            setSelected(totalSelected.slice(0, 400));
        }
        else {
            const newSelected = selected.filter((id) => !visibleRows.some((row) => row.orderId === id));
            setSelected(newSelected);
            setBulkAction("");
        }
    };
    const handleClickCheckbox = (orderId) => {
        const selectedIndex = selected.indexOf(orderId);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = [...selected, orderId];
        }
        else {
            newSelected = selected.filter((id) => id !== orderId);
        }
        setSelected(newSelected);
    };
    const isSelectAllChecked = () => {
        const prevSelected = [...selected];
        const newSelected = prevSelected.filter((item) => {
            const orderOnCurrentPage = visibleRows.filter((row) => (row === null || row === void 0 ? void 0 : row.orderId) === item && (row === null || row === void 0 ? void 0 : row.processingStatus) === "in_review");
            return (orderOnCurrentPage === null || orderOnCurrentPage === void 0 ? void 0 : orderOnCurrentPage.length) > 0;
        });
        return (newSelected === null || newSelected === void 0 ? void 0 : newSelected.length) > 0;
    };
    const visibleRows = React.useMemo(() => {
        return discrepancies.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    }, [discrepancies, page, rowsPerPage]);
    return (React.createElement(Grid, { container: true, direction: "row", paddingTop: 2, className: "m_background_color" },
        React.createElement(BackDropComponent, { open: isBackOpenOpen }),
        React.createElement(Grid, { className: "grid_container", container: true, direction: "row", justifyContent: "space-between", style: { width: "100%", marginBottom: "6px" } },
            React.createElement(Grid, { container: true, item: true, xs: 8.2, alignItems: "center", width: "100%", gap: 1 },
                React.createElement(Grid, { item: true, sx: { width: "110px" }, container: true, justifyContent: "flex-start", alignItems: "center", ml: "6px" },
                    React.createElement(Checkbox, { indeterminate: isSelectAllChecked(), checked: isSelectAllChecked(), onChange: handleSelectAllClick, sx: {
                            transform: "scale(0.8)", // Reduces the size of the checkbox
                            marginLeft: "-12px",
                        }, inputProps: {
                            "aria-label": "select all orders",
                        } }),
                    React.createElement(Typography, { sx: { marginLeft: 0.2, fontSize: "0.875rem" }, color: "inherit", variant: "subtitle1", component: "div" }, "Select all")),
                React.createElement(Grid, { item: true },
                    React.createElement(Select, { value: bulkAction, displayEmpty: true, size: "small", disabled: (selected === null || selected === void 0 ? void 0 : selected.length) === 0, sx: { marginLeft: 1, fontSize: "0.875rem", borderRadius: "4px" }, onChange: (event) => {
                            const selectedAction = event.target.value;
                            setBulkAction(selectedAction);
                            if (selectedAction === "accept_all_disputes") {
                                handleBulkDisputeDiscrepancy(selected);
                            }
                            else if (selectedAction === "reject_all_disputes") {
                                handleBulkRejectDispute(selected);
                            }
                        } },
                        React.createElement(MenuItem, { value: "", disabled: true }, "Select bulk action"),
                        BULK_ACTION_OPTIONS_WEIGHT_DISPUTE.map((option) => (React.createElement(MenuItem, { key: option.value, value: option.value },
                            React.createElement(Typography, { variant: "body1", className: "m_font_size_14" }, option.name)))))))),
        React.createElement(Grid, { className: "order_table_border", sx: { width: "100%", padding: 0, margin: 0 } },
            React.createElement(Paper, { sx: { width: "100%" } },
                React.createElement(TableContainer, null,
                    React.createElement(Table, { sx: { minWidth: 750, width: "100%" }, className: "or_table", "aria-labelledby": "tableTitle", size: "medium" },
                        React.createElement(EnhancedTableHead, { rowCount: weightDiscrepancy === null || weightDiscrepancy === void 0 ? void 0 : weightDiscrepancy.length, numSelected: selected.length, onSelectAllClick: handleSelectAllClick }),
                        React.createElement(TableBody, { sx: { p: 2 } }, visibleRows && visibleRows.length > 0 ? (visibleRows.map((row, index) => {
                            var _a;
                            const labelId = `enhanced-table-checkbox-${index}`;
                            const isItemSelected = selected.includes(row.orderId);
                            return (React.createElement(TableRow, { hover: true, role: "checkbox", tabIndex: -1, key: row.orderId, sx: { cursor: "pointer" } },
                                React.createElement(TableCell, { padding: "checkbox" },
                                    React.createElement(Checkbox, { color: "primary", checked: isItemSelected, onChange: () => handleClickCheckbox(row.orderId), disabled: (row === null || row === void 0 ? void 0 : row.processingStatus) !== "in_review", sx: {
                                            transform: "scale(0.8)",
                                            pt: 0,
                                        }, inputProps: { "aria-labelledby": labelId } })),
                                React.createElement(TableCell, { className: "orderTable_font", align: "left" },
                                    React.createElement(Grid, { container: true, direction: "row", alignItems: "center", wrap: "nowrap", gap: 0.5 },
                                        React.createElement(Typography, { sx: {
                                                fontFamily: "Poppins",
                                                color: "#121114",
                                                fontSize: "12px",
                                                fontWeight: 500,
                                                whiteSpace: "nowrap",
                                            } }, row.createdAt ? (React.createElement(React.Fragment, null,
                                            React.createElement("div", null, getNewDateString(+row.createdAt).date),
                                            React.createElement("div", { style: { color: "#5F5A6B", fontWeight: 400 } }, getNewDateString(+row.createdAt).time))) : ("-")))),
                                React.createElement(TableCell, { className: "orderTable_font", align: "left" },
                                    React.createElement(Typography, { sx: { fontFamily: "Poppins", color: "#121114", fontSize: "12px", fontWeight: 500 }, component: "div" }, row === null || row === void 0 ? void 0 : row.orderNumber),
                                    React.createElement(Typography, { className: "orderTable_font", variant: "subtitle2", component: "div" },
                                        React.createElement(Link, { variant: "body2", onClick: (e) => handleClickOrderId(e, row), sx: {
                                                cursor: "pointer",
                                                color: "#0C77FF",
                                                textDecoration: "none",
                                                fontFamily: "Poppins",
                                                fontSize: "12px",
                                                fontWeight: 500,
                                            } }, row === null || row === void 0 ? void 0 :
                                            row.orderId.slice(0, 10),
                                            "..."))),
                                React.createElement(TableCell, { align: "left" }, (_a = row.productDetails) === null || _a === void 0 ? void 0 : _a.map((product, index) => {
                                    var _a, _b;
                                    return (React.createElement("div", { key: index },
                                        React.createElement(Typography, { variant: "body2", component: "div", sx: {
                                                textAlign: "left",
                                                fontFamily: "Poppins",
                                                fontSize: "11px",
                                                color: "#5F5A6B",
                                                fontWeight: 400,
                                            } }, ((_a = product.productName) === null || _a === void 0 ? void 0 : _a.length) > 30
                                            ? `${product.productName.slice(0, 30)}...`
                                            : product.productName),
                                        React.createElement(Typography, { variant: "body2", component: "div", sx: {
                                                textAlign: "left",
                                                fontFamily: "Poppins",
                                                fontSize: "11px",
                                                color: "#5F5A6B",
                                                fontWeight: 400,
                                            } },
                                            "SKU: ",
                                            ((_b = product.sku) === null || _b === void 0 ? void 0 : _b.length) > 20 ? `${product.sku.slice(0, 20)}...` : product.sku),
                                        React.createElement(Typography, { variant: "body2", component: "div", sx: {
                                                textAlign: "left",
                                                fontFamily: "Poppins",
                                                fontSize: "11px",
                                                color: "#5F5A6B",
                                                fontWeight: 400,
                                            } },
                                            "Qty: ",
                                            product.quantity),
                                        index < (row === null || row === void 0 ? void 0 : row.productDetails.length) - 1 && React.createElement(Divider, { sx: { my: 1 } }),
                                        " "));
                                })),
                                React.createElement(TableCell, { align: "left", className: "orderTable_font" },
                                    React.createElement(Grid, { container: true, item: true, direction: "row", justifyContent: "center", alignItems: "flex-start", gap: 1 },
                                        React.createElement(Grid, { item: true, xs: 2 },
                                            React.createElement("img", { className: "m_image_icons", src: getCarrierIcon(`${row === null || row === void 0 ? void 0 : row.carrier}`), alt: "icon", style: { width: "18px", height: "18px", borderRadius: "10px" } })),
                                        React.createElement(Grid, { item: true, xs: 9 },
                                            React.createElement(Typography, { sx: {
                                                    fontFamily: "Poppins",
                                                    color: "#121114",
                                                    fontSize: "12px",
                                                    fontWeight: 500,
                                                } }, row === null || row === void 0 ? void 0 : row.carrier),
                                            React.createElement(Typography, { sx: {
                                                    fontFamily: "Poppins",
                                                    color: "#5F5A6B",
                                                    fontSize: "11px",
                                                    fontWeight: 400,
                                                } }, row.service),
                                            React.createElement(Grid, { container: true, direction: "row", alignItems: "center", wrap: "nowrap", gap: 0.5 },
                                                React.createElement(Typography, { sx: {
                                                        fontFamily: "Poppins",
                                                        color: "#5F5A6B",
                                                        fontSize: "11px",
                                                        fontWeight: 500,
                                                        whiteSpace: "nowrap", // prevents text wrapping
                                                    } },
                                                    "AWB# ",
                                                    row.trackingNumber),
                                                React.createElement("img", { className: "m_image_icons", src: require("../../../assets/Onboarding/CopyIcon.svg").default, alt: "icon", style: { width: "15px", height: "15px", cursor: "pointer" }, onClick: () => handleCopyAWB(row.trackingNumber) }))))),
                                React.createElement(TableCell, { align: "left" },
                                    React.createElement(Typography, { variant: "subtitle2", component: "div", className: "orderTable_font", sx: {
                                            textAlign: "left",
                                            fontFamily: "Poppins",
                                            fontSize: "12px",
                                            color: "#121114",
                                            fontWeight: 500,
                                        } }, row === null || row === void 0 ? void 0 :
                                        row.manifestedDeadWeight,
                                        " kg"),
                                    React.createElement(Typography, { variant: "body2", component: "div", sx: {
                                            textAlign: "left",
                                            fontFamily: "Poppins",
                                            fontSize: "10px",
                                            color: "#5F5A6B",
                                            fontWeight: 400,
                                        } },
                                        "Dead Weight: ", row === null || row === void 0 ? void 0 :
                                        row.manifestedDeadWeight,
                                        " kg"),
                                    React.createElement(Typography, { variant: "body2", component: "div", sx: {
                                            textAlign: "left",
                                            fontFamily: "Poppins",
                                            fontSize: "10px",
                                            color: "#5F5A6B",
                                            fontWeight: 400,
                                        } }, "Volumatric Weight"),
                                    React.createElement(Typography, { variant: "body2", component: "div", sx: {
                                            textAlign: "left",
                                            fontFamily: "Poppins",
                                            fontSize: "10px",
                                            color: "#5F5A6B",
                                            fontWeight: 400,
                                        } },
                                        row.volumetricWeight,
                                        "kg (",
                                        row.manifestedLength,
                                        "*",
                                        row.manifestedWidth,
                                        "*",
                                        row.manifestedHeight,
                                        " cm)")),
                                React.createElement(TableCell, { align: "left", className: "orderTable_font" },
                                    React.createElement(Typography, { variant: "subtitle2", component: "div", className: "orderTable_font", sx: {
                                            textAlign: "left",
                                            fontFamily: "Poppins",
                                            fontSize: "12px",
                                            color: "#121114",
                                            fontWeight: 500,
                                        } }, row === null || row === void 0 ? void 0 :
                                        row.carrierAppliedWeightKg,
                                        " kg"),
                                    React.createElement(Typography, { variant: "body2", component: "div", sx: {
                                            textAlign: "left",
                                            fontFamily: "Poppins",
                                            fontSize: "10px",
                                            color: "#5F5A6B",
                                            fontWeight: 400,
                                        } },
                                        "Charged weight: ",
                                        row.volumetricWeight,
                                        " kg")),
                                React.createElement(TableCell, { align: "left", className: "orderTable_font" },
                                    React.createElement(Typography, { className: "orderTable_font", variant: "subtitle2", component: "span", sx: { ml: 1 } },
                                        React.createElement(Typography, { variant: "subtitle2", component: "div", className: "orderTable_font", sx: {
                                                textAlign: "left",
                                                fontFamily: "Poppins",
                                                fontSize: "12px",
                                                color: "#121114",
                                                fontWeight: 500,
                                            } }, "Excess Weight:"),
                                        React.createElement(Typography, { variant: "body2", component: "div", sx: {
                                                textAlign: "left",
                                                fontFamily: "Poppins",
                                                fontSize: "10px",
                                                color: "#5F5A6B",
                                                fontWeight: 400,
                                            } }, row === null || row === void 0 ? void 0 :
                                            row.weightDiscrepancyKg,
                                            " kg"),
                                        React.createElement(Typography, { variant: "subtitle2", component: "div", className: "orderTable_font", sx: {
                                                textAlign: "left",
                                                fontFamily: "Poppins",
                                                fontSize: "12px",
                                                color: "#121114",
                                                fontWeight: 500,
                                            } }, "Excess Charges:"),
                                        React.createElement(Typography, { variant: "body2", component: "div", sx: {
                                                textAlign: "left",
                                                fontFamily: "Poppins",
                                                fontSize: "10px",
                                                color: "#5F5A6B",
                                                fontWeight: 400,
                                            } },
                                            row.weightDiscrepancyCharges,
                                            " INR"))),
                                React.createElement(TableCell, { align: "left", className: "orderTable_font" },
                                    React.createElement(Typography, { className: "orderTable_font", variant: "subtitle2", component: "span", sx: { ml: 1 } },
                                        React.createElement(Chip, { label: getStatusLabel(row === null || row === void 0 ? void 0 : row.processingStatus), variant: "outlined", size: "small", className: "tr_chip m_font_size_12", style: {
                                                color: getStatusColor(row === null || row === void 0 ? void 0 : row.processingStatus),
                                                backgroundColor: getBackgroundColor(row === null || row === void 0 ? void 0 : row.processingStatus),
                                                border: "none",
                                            } }))),
                                React.createElement(TableCell, { align: "left", className: "orderTable_font" },
                                    React.createElement(Box, { display: "flex", flexDirection: "column", gap: 1 },
                                        React.createElement(Button, { variant: "outlined", sx: {
                                                color: "#121114",
                                                borderColor: "#121114",
                                                textTransform: "none",
                                                width: "160px",
                                                height: "28px",
                                                "&.Mui-disabled": {
                                                    color: "#9e9e9e",
                                                    borderColor: "#bdbdbd",
                                                },
                                            }, onClick: () => handleRejectDispute(row), disabled: (row === null || row === void 0 ? void 0 : row.processingStatus) !== "in_review" }, "Reject dispute"),
                                        React.createElement(Button, { variant: "outlined", sx: {
                                                color: "#121114",
                                                borderColor: "#121114",
                                                textTransform: "none",
                                                width: "160px",
                                                height: "28px",
                                                "&.Mui-disabled": {
                                                    color: "#9e9e9e",
                                                    borderColor: "#bdbdbd",
                                                },
                                            }, onClick: () => handleAcceptDispute(row), disabled: (row === null || row === void 0 ? void 0 : row.processingStatus) !== "in_review" }, "Accept dispute")),
                                    React.createElement(Typography, { align: "left", fontSize: "8px", fontWeight: 400, sx: { color: "#5F5A6B" } },
                                        "If not disputed by",
                                        " ",
                                        React.createElement("span", { style: { fontWeight: 700 } }, row.disputeDeadline ? formatTimestampToDayMonth(Number(row.disputeDeadline)) : "--"),
                                        ", charges will be marked closed."))));
                        })) : (React.createElement(TableRow, null,
                            React.createElement(TableCell, { colSpan: headCells.length, align: "center", sx: { width: "100%" } }, "No data available")))))),
                React.createElement(TablePagination, { rowsPerPageOptions: [5, 10, 25], component: "div", count: totalCount, rowsPerPage: rowsPerPage, page: page, onPageChange: handleChangePage, onRowsPerPageChange: handleChangeRowsPerPage })),
            isRejectModalOpen && selectedRowData && selectedRow && (React.createElement(RejectDisputeModal, { open: isRejectModalOpen, onClose: () => setIsRejectModalOpen(false), selectedRow: selectedRow, selectedRowData: selectedRowData, setIsBackOpenOpen: setIsBackOpenOpen })),
            isRejectBulkModalOpen && orderIds && selectedRow && (React.createElement(BulkDisputeModal, { open: isRejectBulkModalOpen, onClose: () => setIsRejectBulkModalOpen(false), selectedRow: selectedRow, orderIds: orderIds, setIsBackOpenOpen: setIsBackOpenOpen })),
            React.createElement(Popover, { id: copyPopoverId, open: openCopyPopover, anchorEl: copyAnchorEl, onClose: handleCopyClose, slotProps: {
                    paper: {
                        sx: {
                            boxShadow: "0px 4px 4px 0px rgba(206, 216, 228, 0.25)",
                            border: "1px solid #EAEBF1",
                        },
                    },
                }, anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                } },
                React.createElement(Grid, { container: true, direction: "column", justifyContent: "flex-start", spacing: 0.5, alignItems: "flex-start", sx: { p: 1 } },
                    React.createElement(Grid, { item: true },
                        React.createElement(Typography, { variant: "body2", component: "div", className: "orderTable_small_font" }, "Order Id:")),
                    React.createElement(Grid, { item: true, container: true, direction: "row", alignItems: "center" },
                        React.createElement(Typography, { variant: "body2", sx: { mr: 1 } }, orderId),
                        React.createElement(IconButton, { sx: { color: isOrderIdCopied ? "#0A6EBD" : "inherit" }, onClick: () => handleCopyOrderId(orderId), size: "small" },
                            React.createElement(ContentCopyIcon, { fontSize: "small" }))))),
            React.createElement(Popover, { id: id, open: Boolean(anchorEl), anchorEl: anchorEl, onClose: handleClosePopOver, slotProps: {
                    paper: {
                        sx: {
                            boxShadow: "0px 4px 4px 0px rgba(206, 216, 228, 0.25)",
                            border: "1px solid #EAEBF1",
                            width: "150px",
                            p: 1,
                        },
                    },
                }, anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center",
                }, transformOrigin: {
                    vertical: "top",
                    horizontal: "right",
                } },
                React.createElement(MenuItem, { onClick: () => {
                        if (selectedRowData) {
                            handleDetailsSlider(selectedRowData);
                            handleClosePopOver();
                        }
                    } }, "Details")))));
};
export default OpenDisputeComponent;
